import { MotherNurseIcon } from './MotherNurseIcon';

/**
 * author: Michael Irigoyen
 * id ACE8B129-F064-47BF-9FD5-AB472736ED43
 * name mother-nurse
 * version: 3.3.92
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/mother-nurse.svg
 * tags
 * - Medical / Hospital 
 * - People / Family 
 */
export const BreastFeedIcon = MotherNurseIcon;
export default BreastFeedIcon